import { fetchRouteUrl, postRouteUrl } from './../utilities/url_util';
import {
  FETCH_POI_ROUTE_SUCCESS,
  FETCH_POI_ROUTE_FAIL,
  FETCH_POI_ROUTE,
  CHANGE_TRANSPORTATION_TYPE,
  CHANGE_TRANSPORTATION_TYPE_SUCCESS,
  CHANGE_TRANSPORTATION_TYPE_FAIL,
  TRIGGER_DIRECTION_MANAGER,
  // CHANGE_ROUTING_PREFERENCES,
  SET_TRANSPORTATION_AIRPLANE_TYPE,
  SET_AIRPLANE_APPROXIMATE_TRANSPORTATION_TIME_FLAG,
} from './action_types';
import { VIEW_STATE_ITINERARY } from './../reducers/view_state';
import { getBasicParameters } from './../utilities/parameter_util';
import {
  TRANSPORTATION_TYPE_DRIVING,
  TRANSPORTATION_TYPE_DRIVING_FROM_WEB,
  TRANSPORTATION_TYPE_TRANSIT,
  TRANSPORTATION_TYPE_TRANSIT_FROM_WEB,
  TRANSPORTATION_TYPE_OSRM_DRIVING,
} from './../utilities/constants';
import { funlidayRequest } from '../apis/main';

// fetch route from funliday server
export const fetchRoute = (tripObjectId, poiObjectId, intlLocale) => {
  const url = fetchRouteUrl();
  return dispatch => {
    dispatch({ type: FETCH_POI_ROUTE, payload: { poiObjectId } });
    const parameters = getBasicParameters();
    parameters.parseTripObjectId = tripObjectId;
    parameters.parsePoiObjectId = poiObjectId;
    parameters.language = intlLocale;
    funlidayRequest
      .post(url, parameters)
      .then(response => {
        if (response.data.status === '200') {
          const { status, results } = response.data;
          dispatch({
            type: FETCH_POI_ROUTE_SUCCESS,
            payload: { status, poiObjectId, results },
          });
        } else {
          const { status, message } = response.data;
          dispatch({
            type: FETCH_POI_ROUTE_FAIL,
            payload: { status, poiObjectId, errorMessage: message },
          });
        }
      })
      .catch(error => {
        dispatch({
          type: FETCH_POI_ROUTE_FAIL,
          payload: { status: '404', poiObjectId, errorMessage: error.message },
        });
      });
  };
};

export const changeTransportationType = (
  accessToken,
  memberObjectId,
  tripObjectId,
  poiObjectId,
  type,
  revision,
) => {
  const parameters = {
    ...getBasicParameters(),
    parseTripObjectId: tripObjectId,
    parsePoiObjectId: poiObjectId,
    transportationType: type.toString(),
    transportationTime: '-1',
    overviewPolyline: '',
    route: {},
    revision,
  };

  const url = postRouteUrl();
  return dispatch => {
    dispatch({
      type: CHANGE_TRANSPORTATION_TYPE,
      payload: { poiObjectId, transportationType: type },
    });
    funlidayRequest
      .post(url, parameters)
      .then(response => {
        const { results } = response.data;
        if (response.data.status === '200') {
          dispatch({
            type: CHANGE_TRANSPORTATION_TYPE_SUCCESS,
            payload: {
              status,
              poiObjectId,
              transportationType: type,
              results,
            },
          });
        } else {
          const { status, message } = response.data;
          dispatch({
            type: CHANGE_TRANSPORTATION_TYPE_FAIL,
            payload: {
              status,
              poiObjectId,
              transportationType: type,
              errorMessage: message,
              toastViewState: VIEW_STATE_ITINERARY,
            },
          });
        }
      })
      .catch(error => {
        dispatch({
          type: CHANGE_TRANSPORTATION_TYPE_FAIL,
          payload: {
            status: '404',
            poiObjectId,
            transportationType: type.toString(),
            errorMessage: error.message,
            toastViewState: VIEW_STATE_ITINERARY,
          },
        });
      });
  };
};

export const changeRoutingPreference = (
  accessToken,
  memberObjectId,
  tripObjectId,
  poiObjectId,
  type,
  drivingRestriction,
  transitMode,
  revision,
) => {
  const parameters = {
    ...getBasicParameters(),
    parseTripObjectId: tripObjectId,
    parsePoiObjectId: poiObjectId,
    transportationType: type.toString(),
    transportationTime: '-1',
    overviewPolyline: '',
    route: {},
    revision,
  };

  if (
    type === TRANSPORTATION_TYPE_DRIVING ||
    type === TRANSPORTATION_TYPE_DRIVING_FROM_WEB ||
    type === TRANSPORTATION_TYPE_OSRM_DRIVING
  ) {
    parameters.drivingRestriction = drivingRestriction.toString();
  }

  if (
    type === TRANSPORTATION_TYPE_TRANSIT ||
    type === TRANSPORTATION_TYPE_TRANSIT_FROM_WEB
  ) {
    parameters.transitMode = transitMode.toString();
  }

  const url = postRouteUrl();
  return dispatch => {
    dispatch({
      type: CHANGE_TRANSPORTATION_TYPE,
      payload: { poiObjectId, transportationType: type },
    });
    funlidayRequest
      .post(url, parameters)
      .then(response => {
        console.log('postRoute =', response);
        const { results } = response.data;
        if (response.data.status === '200') {
          dispatch({
            type: CHANGE_TRANSPORTATION_TYPE_SUCCESS,
            payload: {
              status,
              poiObjectId,
              transportationType: type,
              results,
            },
          });
        } else {
          const { status, message } = response.data;
          dispatch({
            type: CHANGE_TRANSPORTATION_TYPE_FAIL,
            payload: {
              status,
              poiObjectId,
              transportationType: type,
              errorMessage: message,
              toastViewState: VIEW_STATE_ITINERARY,
            },
          });
        }
      })
      .catch(error => {
        dispatch({
          type: CHANGE_TRANSPORTATION_TYPE_FAIL,
          payload: {
            status: '404',
            poiObjectId,
            transportationType: type.toString(),
            errorMessage: error.message,
            toastViewState: VIEW_STATE_ITINERARY,
          },
        });
      });
  };
};

export const triggerDirectionManager = () => ({
  type: TRIGGER_DIRECTION_MANAGER,
});

export const setTransportationAirplaneType = fromPoi => {
  return {
    type: SET_TRANSPORTATION_AIRPLANE_TYPE,
    payload: { _id: fromPoi._id, daySequence: fromPoi.daySequence },
  };
};
export const setAirplaneApproximateTransporataionTimeFlag = fromPoi => {
  return {
    type: SET_AIRPLANE_APPROXIMATE_TRANSPORTATION_TIME_FLAG,
    payload: { fromPoi },
  };
};
